import React, { useEffect, useState } from 'react';
import { Clock } from 'lucide-react';
export function UrgencyBanner() {
  const [timeLeft, setTimeLeft] = useState(7200);
  useEffect(() => {
    if (timeLeft <= 0) return;
    const timerId = setInterval(() => {
      setTimeLeft(prev => prev - 1);
    }, 1000);
    return () => clearInterval(timerId);
  }, [timeLeft]);
  const hours = Math.floor(timeLeft % (3600 * 24) / 3600);
  const minutes = Math.floor(timeLeft % 3600 / 60);
  const seconds = timeLeft % 60;
  const pad = (n: number) => String(n).padStart(2, '0');
  return <div className="bg-[#004D40] py-1 px-4" data-id="element-201">
      <div className="max-w-4xl mx-auto flex items-center justify-center gap-2 flex-wrap" data-id="element-202">
        <Clock className="w-3.5 h-3.5 text-white" data-id="element-203" />
        <span className="text-white font-semibold text-xs" data-id="element-204">
          Oferta especial termina en:
        </span>
        <div className="flex items-center gap-0.5" data-id="element-205">
          <span className="bg-white/20 text-white font-bold text-sm px-1.5 py-0.5 rounded" data-id="element-206">
            {pad(hours)}
          </span>
          <span className="text-white font-bold text-xs" data-id="element-207">:</span>
          <span className="bg-white/20 text-white font-bold text-sm px-1.5 py-0.5 rounded" data-id="element-208">
            {pad(minutes)}
          </span>
          <span className="text-white font-bold text-xs" data-id="element-209">:</span>
          <span className="bg-white/20 text-white font-bold text-sm px-1.5 py-0.5 rounded" data-id="element-210">
            {pad(seconds)}
          </span>
        </div>
      </div>
    </div>;
}